// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"315":"dfb5b99b","330":"e835f15a","426":"c6f66d62","524":"dddc0ebb","548":"31d6cfe0","857":"ad270ad5","981":"41360011"}[chunkId] + ".chunk.css";
};